"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint-disable */
__export(require("./BasicResponse"));
__export(require("./LDAP"));
__export(require("./Owner"));
__export(require("./ReqCreateLdap"));
__export(require("./ReqCreateSite"));
__export(require("./ReqCreateTenant"));
__export(require("./RespCreateLdap"));
__export(require("./RespCreateOwner"));
__export(require("./RespCreateSite"));
__export(require("./RespCreateTenant"));
__export(require("./RespDeleteLdap"));
__export(require("./RespDeleteOwner"));
__export(require("./RespDeleteSite"));
__export(require("./RespDeleteTenant"));
__export(require("./RespGetLdap"));
__export(require("./RespGetOwner"));
__export(require("./RespGetSite"));
__export(require("./RespGetTenant"));
__export(require("./RespListLdaps"));
__export(require("./RespListOwners"));
__export(require("./RespListSites"));
__export(require("./RespListTenants"));
__export(require("./Site"));
__export(require("./Tenant"));
